import { render, staticRenderFns } from "./CustomerPopComponent.vue?vue&type=template&id=4ec9da08&scoped=true"
import script from "./CustomerPopComponent.vue?vue&type=script&lang=js"
export * from "./CustomerPopComponent.vue?vue&type=script&lang=js"
import "./CustomerPopComponent.vue?vue&type=style&index=0&id=4ec9da08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec9da08",
  null
  
)

export default component.exports